import { useEffect, useState, createContext } from "react";
// import { } from "react-router";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
} from "react-router-dom";
import PendingResumeValidationsPage from "./pages/pendingResumeValidations/pendingResumeValidationsPage.js";
import AddQuestion from "./pages/addQuestion/addQuestion";
import SearchRequisitions from "./pages/Searchrequisitions/searchRequisitions.js";
import Activity from "./pages/activity/activity.js";
import Home from "./pages/home/home";
import Referral from "./pages/referral/referral";
import ReferralInvite from "./pages/referral/referralInvite";
import Landing from "./pages/landing/landing";
import Profile from "./pages/profile/profile";
import Search from "./pages/search/search";
import AddPrimarySkill from "./pages/primarySkill/addPrimarySkill";
import Subskill from "./pages/subSkill/subskill";
import AdminProfile from "./pages/adminApplication/AdminApplication";
import TestResult from "./components/testResult/TestResult";
import { TermsAndCondition } from "./components/termsAndCondition/termsAndCondition";
import PrivacyPolicy from "./components/privacyPolicy/privacyPolicy";
import UserList from "./pages/userList/userList";
import RegisteredStartTest from "./components/registeredStartTest/registeredStartTest";
import EmailConfiguration from "./pages/emailConfiguration/emailConfiguration";
import QuestionReport from "./pages/questionReport/questionReport";
import QuestionsList from "./pages/questionsList/questionsList";
import EditQuestion from "./pages/editQuestion/editQuestion";
import Domain from "./pages/domain/domain";
import EmployerPage from "./pages/home/EmployerPage/EmployerPage";
import AdminLanding from "./pages/adminLanding/adminLanding";
import SignIn from "./pages/candidateSignIn/signin.js";
import ProtectedRoute from "./protectedRoute";
import FormOne from "./components/basicInfoForm/FormOne";
import SkillTestConfigaration from "./pages/globalConfiguration/globalConfiguration";
import SharedAdminApplication from "./pages/adminApplication/sharedAdminApplication";
import RecruiterSignUp from "./pages/recruiterSignUp/recruiterSignUp";
import Recruiters from "./pages/recruiters/recruiters";
import AccountSetting from "./pages/myTalentCommunity/accountSetting";
import Invite from "./components/invite/invite";
import RecruiterPrivateSkillAccess from "./pages/recruiterPrivateSkillAccess/recruiterPrivateSkillAccess";
import RecruitmentPartnersAndClients from "./pages/RecruitmentPartnersAndClients/RecruitmentPartnersAndClients";
import Candidate from "./pages/candidate/candidate";
import InviteCandidates from "./pages/InviteCandidates/inviteCandidates";
import AllTests from "./pages/allTests/AllTests";
import { jwtDecode } from "jwt-decode";
import InviteTestLanding from "./pages/inviteTestLanding/inviteTestLanding";
import PendingInvites from "./pages/myTalentCommunity/pendingInvites";
import MyTalentReferral from "./pages/myTalentCommunity/myTalentReferral";
import { DateTime } from "luxon";
import Error404 from "./pages/errorPage/error404";
import SessionTimeout from "./pages/sessionTimeout/sessionTimeout.js";
import AdminReferral from "./pages/adminReferral/AdminReferral";
import TestLandingPage from "./components/basicInfoForm/TestLandingPage";
import CandidateTestLanding from "./components/profile/testLandingPage/CandidateTestLandingPage";
import axios from "axios";
import AdvanceSearchTalentCommunity from "./pages/myTalentCommunity/advanceSearch/AdvanceSearchTalentCommunity.js";
import OnlyCandidateProfile from "./components/candidateProfile/onlycandidateProfile/candidateprofile.js";
import RequisitionDetails from "./pages/RequisitionDetails/RequisitionDetails.js";
import CreateRequisition from "./pages/createRequisition/createRequisition.js";
import Notification from "./pages/notification/notification.js";
import RequisitionReports from "./components/RequisitionReports/RequisitionReports.js";
import TrackCandidate from "./pages/TrackCandidate/TrackCandidate.js";
import ManageDivision from "./pages/organisationAdmin/manageDivision.js";
import ManageClient from "./pages/organisationAdmin/manageClient.js";
import ManageSpoc from "./pages/organisationAdmin/manageSpoc.js";
import RequisitionDashboard from "./pages/RequisitionDashboard/RequisitionDashboard.js";
import Dashboard from "./pages/ATS_Dashboard/Dashboard.js";
import RequisitionReportDetails from "./pages/RequisitionReportDetails/RequisitionReportDetails.js";
import ManageTeam from "./pages/organisationAdmin/manageTeam.js";
import RTRconfirmation from "./pages/RTRConfirmation/RTRConfirmation.js";
import CircularProgress from "@mui/material/CircularProgress";
import Layout from "./components/Layout/Layout";
import Interview from "./pages/interview/interview.js";
import UserDetails from "./pages/userdetailsinterview/userdetailsinterview.js";
import InterviewAnalysis from "./pages/interviewanalysis/interviewanalysis.js"
import InterViewManagement from './pages/interviewmanagementcon/interviewmanagement.js';
import JdCandidateList from "./pages/jobdesccandidatelist/jdcandidatelist.js";
import { ThankYouPage } from "./pages/thankyoupage/thankyoupage.js";
import InterviewManagementVet from "./pages/interviewmanagementvet/interviewManagementVet.js";

export const UserTypeContext = createContext();

// Layout component that wraps all routes
const AppLayout = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

// No layout wrapper for public routes
const PublicLayout = () => {
  return <Outlet />;
};
const AppRoute = () => {
  const [idContextTest, setIdContextTest] = useState(null);
  const [testInfo, settestInfo] = useState({});
  const token = localStorage.getItem("token");
  const [currSession, setcurrSession] = useState(false);
  const [userType, setuserType] = useState("");
  const [userIdType, setuserIdType] = useState("");
  const [userRecruitmentpartnerId, setuserRecruitmentpartnerId] = useState("");
  const [userRecords, setUserRecords] = useState({});
  const [referralPartners, setReferralPartners] = useState([]);
  const jsonConfig = require("./Config.json");
  useEffect(() => {
    (async () => {
      if (token) {
        pareentCallback(token);
      }
    })();
    return () => {
      setcurrSession(false);
      setIdContextTest(null);
    };
  }, []);
  const switchRole = (newRole) => {
    setuserType(newRole);
    localStorage.setItem("role", newRole);
    setUserRecords((prevRecords) => ({
      ...prevRecords,
      role: {
        ...prevRecords.role,
        roleName: newRole,
      },
    }));
  };
  const getUser = async (id, isReferral = false) => {
    try {
      const queryParams = isReferral ? "?isReferral=true" : "";
      const userResponse = await axios.get(
        jsonConfig.apiUrl + "users/" + id + queryParams,
        {
          headers: {
            "x-functions-key": jsonConfig.key,
          },
        }
      );
      setuserIdType(userResponse.data.data[0]?.id);
      setuserRecruitmentpartnerId(
        userResponse.data.data[0]?.recruitmentpartnerId
      );

      const storedRole = localStorage.getItem("role");
      const currentRole =
        storedRole || userResponse.data.data[0]?.role?.roleName;
      setuserType(currentRole);

      const userData = userResponse?.data?.data[0];
      if (storedRole && userData?.role) {
        userData.role = {
          ...userData.role,
          roleName: storedRole,
        };
      }
      setUserRecords(userData);

      if (userResponse?.data?.referralpartners === true) {
        setReferralPartners(userResponse?.data?.referralpartners);
      }
    } catch (error) {
      console.error("%c" + error, "color:red");
    }
  };
  const pareentCallback = async (data, test) => {
    if (data) {
      await tokenExpireVerification(data);
    }
    if (test) {
      settestInfo(test);
    }
  };

  const tokenExpireVerification = async (data) => {
    try {
      const decodedJwt = jwtDecode(data);
      if (decodedJwt) {
        if (decodedJwt.exp < DateTime.now().toUnixInteger()) {
          // alert("okkkkkk")
          setcurrSession(false);
          localStorage.clear();
          window.location.href = "/sessionExpired";
        } else {
          setIdContextTest(decodedJwt.id);
          setcurrSession(true);
          await getUser(decodedJwt.id);
        }
      } else {
        setcurrSession(false);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <UserTypeContext.Provider
      value={{
        userType,
        userIdType,
        userRecruitmentpartnerId,
        userRecords,
        referralPartners,
        switchRole,
      }}
    >
      {
        // Only render the router when authentication state is ready
        token && (!idContextTest || !userType) ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            <Router>
              <Routes>
                {/* Wrap all routes with Layout */}
                <Route element={<PublicLayout />}>
                  {/* Public Routes */}
                  <Route
                    path="/signIn"
                    element={
                      <SignIn pareentCallback={pareentCallback} />
                    }
                  />
                  <Route path="/referral" element={<Referral />} />
                  <Route path="/startInterview" element={<Interview />} />
                  <Route path="/end-interview" element={<ThankYouPage />} />
                  <Route
                    path="/recruiter-signup"
                    element={<RecruiterSignUp />}
                  />
                  <Route path="/basic-info-form" element={<FormOne />} />
                  <Route path="/terms-of-use" element={<TermsAndCondition />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route
                    path="/video-skill-test-registered"
                    element={<RegisteredStartTest />}
                  />
                  <Route path="/demo" element={<EmployerPage />} />
                  <Route path="/test/:id" element={<TestResult />} />
                  <Route
                    path="/profile/shared/:id"
                    element={<SharedAdminApplication />}
                  />
                  <Route path="/invite/:id" element={<Invite />} />
                  <Route path="/referral/:id" element={<ReferralInvite />} />
                  <Route path="/sessionExpired" element={<SessionTimeout />} />
                  <Route path="/test-landing" element={<TestLandingPage />} />
                  <Route
                    path="/rightToRepresent"
                    element={<RTRconfirmation />}
                  />
                  <Route path="/" element={<Home />} />
                  <Route path="/interview/:id" element={<UserDetails />} />

                  {/* Protected Routes */}
                  <Route element={<ProtectedRoute element={<AppLayout />} />}>
                    <Route path="/landing" element={<Landing idContextTest={idContextTest} />} />
                    <Route path="/recruiters" element={<Recruiters idContextTest={idContextTest} />} />
                    <Route path="/sign-up-requests" element={<Recruiters idContextTest={idContextTest} />} />
                    <Route path="/sign-up-page" element={<Recruiters idContextTest={idContextTest} />} />
                    <Route path="/profile" element={<Profile idContextTest={idContextTest} />} />
                    <Route path="/create-requisition" element={<CreateRequisition idContextTest={idContextTest} />} />
                    <Route path="/all-notification" element={<Notification id={idContextTest} userRecruitmentpartnerId={userRecruitmentpartnerId} />} />
                    <Route path="/pending-invites" element={<PendingInvites />} />
                    <Route path="/mytalent-referral" element={<MyTalentReferral />} />
                    <Route path="/account-settings" element={<AccountSetting idContextTest={idContextTest} />} />
                    <Route path="/pending-resume-validations" element={<PendingResumeValidationsPage id={idContextTest} userRecords={userRecords} userType={userType} userRecruitmentpartnerId={userRecruitmentpartnerId} />} />
                    <Route path="/invite-candidates" element={<InviteCandidates idContextTest={idContextTest} />} />
                    <Route path="/invite-candidates/:email" element={<InviteCandidates idContextTest={idContextTest} />} />
                    <Route path="/admin-home" element={<AdminLanding idContextTest={idContextTest} />} />
                    <Route path="/users" element={<UserList idContextTest={idContextTest} />} />
                    <Route path="/emailconfiguration" element={<EmailConfiguration idContextTest={idContextTest} />} />
                    <Route path="/globalconfiguration" element={<SkillTestConfigaration idContextTest={idContextTest} />} />
                    <Route path="/search" element={<Search idContextTest={idContextTest} />} />
                    <Route path="/domain" element={<Domain idContextTest={idContextTest} />} />
                    <Route path="/skills" element={<AddPrimarySkill idContextTest={idContextTest} />} />
                    <Route path="/recruitment-organizations-customers-and-agencies" element={<RecruitmentPartnersAndClients idContextTest={idContextTest} />} />
                    <Route path="/admin-referral" element={<AdminReferral idContextTest={idContextTest} />} />
                    <Route path="/subskill" element={<Subskill idContextTest={idContextTest} />} />
                    <Route path="/questions" element={<QuestionsList idContextTest={idContextTest} />} />
                    <Route path="/addquestion" element={<AddQuestion idContextTest={idContextTest} />} />
                    <Route path="/reported-question" element={<QuestionReport idContextTest={idContextTest} />} />
                    <Route path="questions/:id" element={<EditQuestion idContextTest={idContextTest} />} />
                    <Route path="/requisition-details/:id" element={<RequisitionDetails />} />
                    <Route path="/candidate-history" element={<TrackCandidate id={idContextTest} />} />
                    <Route path="/questions/:id" element={<EditQuestion idContextTest={idContextTest} />} />
                    <Route path="/candidate/profile/:id/:recruitmentpartnerId" element={<AdminProfile idContextTest={idContextTest} />} />
                    <Route path="/client-specific-test-access" element={<RecruiterPrivateSkillAccess idContextTest={idContextTest} />} />
                    <Route path="/pending-candidate-invites" element={<Candidate idContextTest={idContextTest} />} />
                    <Route path="/tests" element={<AllTests idContextTest={idContextTest} />} />
                    <Route path="/invitedtest-landing" element={<InviteTestLanding idContextTest={idContextTest} testInfo={testInfo} />} />
                    <Route path="/candidate-test-landing" element={<CandidateTestLanding idContextTest={idContextTest} />} />
                    <Route path="/candidate-search-talent-community" element={<AdvanceSearchTalentCommunity />} />
                    <Route path="/candidate-search-talent-community/:requisitionId" element={<AdvanceSearchTalentCommunity />} />
                    <Route path="/only-candidate-profile/:id" element={<OnlyCandidateProfile idContextTest={idContextTest} userRecruitmentpartnerId={userRecruitmentpartnerId} />} />
                    <Route path="/candidate/profile/:id" element={<AdminProfile idContextTest={idContextTest} />} />
                    <Route path="/requisition-reports" element={<RequisitionReports />} />
                    <Route path="/search-requisitions" element={<SearchRequisitions />} />
                    <Route path="/requisition-report-details" element={<RequisitionReportDetails userType={userType} />} />
                    <Route path="/activity/:id" element={<Activity />} />
                    <Route path="/orgManageDivision" element={<ManageDivision />} />
                    <Route path="/orgManageClient" element={<ManageClient />} />
                    <Route path="/orgManageSpoc" element={<ManageSpoc />} />
                    <Route path="/orgManageTeam" element={<ManageTeam />} />
                    <Route path="/dashboard" element={<Dashboard id={idContextTest} userRecruitmentpartnerId={userRecruitmentpartnerId} userType={userType} userRecords={userRecords} />} />
                    <Route path="/requisition-dashboard" element={<RequisitionDashboard />} />
                    <Route path="/candidate-interview-analysis/:id" element={<InterviewAnalysis />} />

                    <Route
                      path="/interview-management"
                      element={<InterViewManagement />}
                    />
                    <Route
                      path="/interview-management-vet"
                      element={<InterviewManagementVet />}
                    />
                    <Route path="/jdcandidates" element={<JdCandidateList />} />
                  </Route>

                  {/* Fallback 404 route */}
                  <Route
                    path="*"
                    element={
                      <Error404
                        idContextTest={idContextTest}
                        info="Protected"
                      />
                    }
                  />
                </Route>
              </Routes>
            </Router>
          </>
        )
      }
    </UserTypeContext.Provider>
  );
};
export default AppRoute;
